import { NavLink } from "react-router-dom";
import { useState } from "react";
import { X, Mail, Phone  } from "lucide-react";
import "./ScrollNavbar.css";



export default function ScrollNavbar({ visible }) {
  const [menuOpen, setMenuOpen] = useState(false);

  if (!visible) return null;

  return (
    <>
      {/* NAVBAR */}
      <header className="scroll-navbar">
        <NavLink to="/">
          <img
            src="/assets/Logo-HighEnd-Holidays-Gold-small.png"
            alt="Highend Holidays"
          />
        </NavLink>

        {/* Desktop */}
{/* Desktop */}
        <nav className="nav-links">
        <NavLink to="/">Home</NavLink>
        <NavLink to="/apartments">Stays</NavLink>
        <NavLink to="/packages">Packages</NavLink>

        {/* DESKTOP CONTACT */}

        <div className="desktop-contact">
        <div className="desktop-contact-row">
            <div className="desktop-contact-item">
            <Mail size={16} />
            <a href="mailto:info@highendholidays.ae">
                info@highendholidays.ae
            </a>
            </div>

            <div className="desktop-contact-item">
            <Phone size={16} />
            <a href="tel:+971505069469">
                +971 50 506 9469
            </a>
            </div>
        </div>

        <span className="desktop-contact-sub">
            Available 24/7 for bookings & support
        </span>
        </div>

        </nav>


        {/* Mobile */}
            <button className="hamburger" onClick={() => setMenuOpen(true)}>
            <div className="hamburger-icon">
                <span className="line line1" />
                <span className="line line2" />
                <span className="line line3" />
            </div>
            </button>

      </header>

      {/* Overlay */}
      {menuOpen && (
        <div className="mobile-overlay" onClick={() => setMenuOpen(false)} />
      )}

      {/* Mobile Drawer */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-menu-header">
          <strong>Menu</strong>
          <X className="close" onClick={() => setMenuOpen(false)} />
        </div>

        <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
        <NavLink to="/apartments" onClick={() => setMenuOpen(false)}>Stays</NavLink>
        <NavLink to="/packages" onClick={() => setMenuOpen(false)}>Packages</NavLink>

         {/* CONTACT INFO */}
        <div className="mobile-contact">
          <p className="mobile-contact-title">Contact us</p>

          <a href="mailto:info@highendholidays.com" className="mobile-contact-item">
            info@highendholidays.com
          </a>

          <a href="tel:+971501234567" className="mobile-contact-item">
            +971 50 123 4567
          </a>

          <p className="mobile-contact-sub">
            Available 24/7 for bookings & support
          </p>
        </div>

        <div className="mobile-menu-footer">
        © {new Date().getFullYear()} Highend Holidays Homes. All rights reserved.
        </div>

      </div>
    </>
  );
}
